<template>
	<modal ref="viewInvoiceEventModal" :modalSizeClasses="'small-12 columns viewInvoiceEventModal'" v-if="openModal" @closeModal="closeModal">
        <div class="small-12 large-11 columns small-centered modalHeaderWrap flex vertical-align" slot="header">
            <div class="small-12 flex vertical-align justify-between" v-if="event">
                <a class="modalBackButton flex vertical-align" @click="closeTheModal()">
                    <i class="material-icons-outlined">west</i>
                    Back
                </a>
                <p v-if="event.type == 'invoice.create'">Create Invoice Event</p>
                <p v-else-if="event.type == 'invoice.update'">Update Invoice Event</p>
                <p v-else-if="event.type == 'invoice.payment'">Create Invoice Payment Event</p>
            </div>
        </div>
        <div class="small-12 large-11 columns small-centered modalBodyWrap" slot="body" v-if="event">
            <div class="small-12 columns title border borderRadius4">
                <div class="small-12 columns large-6">
                    <h6 class="small-12">Event</h6>
                    <h1 class="small-12 flex vertical-align" v-if="event.type == 'invoice.create'">
                        POST /v{{event.meta.version}}/invoices 
                    </h1>
                    <h1 class="small-12 flex vertical-align" v-else-if="event.type == 'invoice.update'">
                        POST /v{{event.meta.version}}/invoice/update
                    </h1>
                    <h1 class="small-12 flex vertical-align" v-else-if="event.type == 'invoice.payment'">
                        POST /v{{event.meta.version}}/payments
                    </h1>
                </div>
                <div class="small-12 columns large-6 flex justify-right">
                    <h6 class="small-12 text-right id">evt_{{event.id}}</h6>
                    <span class="badge bgGreen borderRadius4">200 OK</span>
                </div>
            </div>
            <div class="small-12 eventDetails border-bottom">
                <div class="small-12 large-6 columns details">
                    <div class="small-12 columns eventSectionTitle">
                        <p>Event Details</p>
                    </div>
                    <ul class="small-12 columns flex float-left">
                        <li class="small-12">
                            <div class="small-4">
                                <p class="eventLabel">Time</p>
                            </div>
                            <div class="small-8">
                                <p class="eventValue small-12 text-overflow">{{event.meta.created_at | unixToDateTime}}</p>
                            </div>
                        </li>
                        <li class="small-12">
                            <div class="small-4">
                                <p class="eventLabel">Application</p>
                            </div>
                            <div class="small-8">
                                <p class="eventValue">Nestd - Web</p>
                            </div>
                        </li>
                        <li class="small-12">
                            <div class="small-4">
                                <p class="eventLabel">User</p>
                            </div>
                            <div class="small-8">
                                <p class="eventValue">{{display_name}}</p>
                            </div>
                        </li>
                        <li class="small-12" v-if="company">
                            <div class="small-4">
                                <p class="eventLabel">Company</p>
                            </div>
                            <div class="small-8" v-if="company">
                                <p class="eventValue" v-if="company.attributes.name.dba">{{company.attributes.name.dba}}</p>
                                <p class="eventValue" v-else>{{company.attributes.name.legal}}</p>
                            </div>
                        </li>
                        <li class="small-12" v-if="resident">
                            <div class="small-4">
                                <p class="eventLabel">Resident</p>
                            </div>
                            <div class="small-8" v-if="resident">
                                <p class="eventValue">{{resident.attributes.contact_information.first_name}} {{resident.attributes.contact_information.last_name}}</p>
                            </div>
                        </li>
                        <li class="small-12">
                            <div class="small-4">
                                <p class="eventLabel">Status</p>
                            </div>
                            <div class="small-8">
                                <p class="eventValue">200 OK</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="small-12 large-6 columns details border-left">
                     <div class="small-12 columns eventSectionTitle">
                        <p>Event Relationships</p>
                    </div>
                    <ul class="small-12 columns flex float-left">
                        <li class="small-12">
                            <div class="small-4">
                                <p class="eventLabel">Company</p>
                            </div>
                            <div class="small-8">
                                <p class="eventValue" v-if="user">
                                    <router-link :to="{ name: 'SettingsCompany' }" class="flex vertical-align" v-if="user">
                                        cmp_{{user.relationships.company}} 
                                        <i class="material-icons-outlined borderRadius4 border transition">north_east</i>
                                    </router-link>
                                </p>
                            </div>
                        </li>
                        <li class="small-12">
                            <div class="small-4">
                                <p class="eventLabel">Property</p>
                            </div>
                            <div class="small-8">
                                <p class="eventValue">
                                    <router-link :to="{ name: 'PropertyDetails', params: { id: event.relationships.property } }" class="flex vertical-align">
                                        prp_{{event.relationships.property}} 
                                        <i class="material-icons-outlined borderRadius4 border transition">north_east</i>
                                    </router-link>
                                </p>
                            </div>
                        </li>
                        <li class="small-12">
                            <div class="small-4">
                                <p class="eventLabel">Lease</p>
                            </div>
                            <div class="small-8">
                                <p class="eventValue">
                                    <router-link :to="{ name: 'LeaseRent', params: { id: event.relationships.property, residentID: event.relationships.resident, leaseID: event.relationships.lease } }" class="flex vertical-align">
                                        lse_{{event.relationships.lease}} 
                                        <i class="material-icons-outlined borderRadius4 border transition">north_east</i>
                                    </router-link>
                                </p>
                            </div>
                        </li>
                        <li class="small-12">
                            <div class="small-4">
                                <p class="eventLabel">Resident</p>
                            </div>
                            <div class="small-8">
                                <p class="eventValue">
                                    <router-link :to="{ name: 'Resident', params: { id: event.relationships.property, residentID: event.relationships.resident } }" class="flex vertical-align">
                                        res_{{event.relationships.resident}} 
                                        <i class="material-icons-outlined borderRadius4 border transition">north_east</i>
                                    </router-link>
                                </p>
                            </div>
                        </li>
                        <li class="small-12">
                            <div class="small-4">
                                <p class="eventLabel">Unit</p>
                            </div>
                            <div class="small-8">
                                <p class="eventValue">
                                    <router-link :to="{ name: 'Unit', params: { id: event.relationships.property, unitID: event.relationships.unit } }" class="flex vertical-align">
                                        unt_{{event.relationships.unit}} 
                                        <i class="material-icons-outlined borderRadius4 border transition">north_east</i>
                                    </router-link>
                                </p>
                            </div>
                        </li>
                        <li class="small-12">
                            <div class="small-4">
                                <p class="eventLabel">Rent Term</p>
                            </div>
                            <div class="small-8">
                                <p class="eventValue">
                                    <router-link :to="{ name: 'LeaseRent', params: { id: event.relationships.property, residentID: event.relationships.resident, leaseID: event.relationships.lease } }" class="flex vertical-align">
                                        ren_{{event.relationships.rent}} 
                                        <i class="material-icons-outlined borderRadius4 border transition">north_east</i>
                                    </router-link>
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="small-12 responseRequest">
                <div class="small-12 large-6 columns response">
                    <div class="small-12 columns eventSectionTitle">
                        <p>Request POST Body</p>
                    </div>
                    <div class="small-12 columns">
                        <invoice-created-event-request :event="event" v-if="event.type == 'invoice.create'"/>
                        <invoice-updated-event-request :event="event" v-else-if="event.type == 'invoice.update'"/>
                        <invoice-payment-event-request :event="event" v-else-if="event.type == 'invoice.payment'"/>
                    </div>
                </div>
                <div class="small-12 large-6 columns response">
                    <div class="small-12 columns eventSectionTitle">
                        <p>Response Body</p>
                    </div>
                    <div class="small-12 columns">
                        <invoice-created-event-response :event="event" v-if="event.type == 'invoice.create'"/>
                        <invoice-updated-event-response :event="event" v-else-if="event.type == 'invoice.update'"/>
                        <invoice-payment-event-response :event="event" v-else-if="event.type == 'invoice.payment'"/>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>

	// Import firebase
	import { firebaseAuth, usersModel } from '@/firebase/firebase-config'

	// Import the mixins
    import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
    import { DatesFilters } from '@/mixins/filters/DatesFilters'

	// Import the components
    import Modal from '@/components/framework/modals/Modal.vue'
    import InvoiceCreatedEventRequest from '@/components/events/invoices/InvoiceCreatedEventRequest.vue'
    import InvoiceCreatedEventResponse from '@/components/events/invoices/InvoiceCreatedEventResponse.vue'
    import InvoiceUpdatedEventRequest from '@/components/events/invoices/InvoiceUpdatedEventRequest.vue'
    import InvoiceUpdatedEventResponse from '@/components/events/invoices/InvoiceUpdatedEventResponse.vue'
    import InvoicePaymentEventRequest from '@/components/events/invoices/InvoicePaymentEventRequest.vue'
    import InvoicePaymentEventResponse from '@/components/events/invoices/InvoicePaymentEventResponse.vue'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'ViewInvoiceEventModal',

		/*
		**  Register the components
		*/

		components: {

            Modal,
            InvoiceCreatedEventRequest,
            InvoiceCreatedEventResponse,
            InvoiceUpdatedEventRequest,
            InvoiceUpdatedEventResponse,
            InvoicePaymentEventRequest,
            InvoicePaymentEventResponse

		},

		/*
		**  Register the mixins
		*/

		mixins: [

            BugsnagService,
            DatesFilters

		],

		/*
		**  Set the props
		*/

		props: {

			modal_action: {
                type: Boolean,
                default: false
            },

            user: {
                type: Object,
                default: () => null
            },

            event: {
                type: Object,
                default: () => null
            },

            company: {
                type: Object,
                default: () => null
            },

            resident: {
                type: Object,
                default: () => null
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

            openModal: false,
            display_name: null

		}),

		/*
		**  Watch em'
		*/

		watch: {

			modal_action: {

				immediate: true, // Load on created
				handler(modal_action) {

                    // Display the modal
                    if (modal_action) {

                        this.showModal();

                        this.setProps();

                    }

				}

            },

		},

		/*
        ** Do this first
        */

        mounted() {

            //

        },

        /*
		**  Set up the methods
		*/

		methods: {

            setProps: function() {

                /*
                **  Set the user name
                **  @prop: @here
                */

                try {

                    this.display_name = firebaseAuth.currentUser.displayName;

                } catch (e) {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Set the display name from Firebase Auth.',
                        errorType: 'Application',
                        section: 'Invoice Event',
                        uid: 'WrHIyncfloaqJ9CdozL1',
                        error: e
                    });

                }

            },

			showModal: function() {

                /*
                **  Show the modal
                */

                try {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.openModal = true;

                    /*
                    **  Set the body class
                    **  @prop: @here
                    */

                    this.addBodyClass();

                } catch (e) {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Show the invoice invent modal.',
                        errorType: 'Application',
                        section: 'Invoice Event',
                        uid: 'gWGexe8baxNgZ8fUjKlV',
                        error: e
                    });

                }

            },

            addBodyClass: function(){

				$('body').addClass('modalFixed');

			},

			removeBodyClass: function(){

				$('body').removeClass('modalFixed');

            },

            closeModal: function() {

                /*
                **  Close the modal
                */

                try {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.openModal = false;
 
                    /*
                    **  Emit the close event
                    **  @service: @Vue
                    */

                    this.$emit('closeViewEventModal');

                } catch (e) {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Close the invoice invent modal.',
                        errorType: 'Application',
                        section: 'Invoice Event',
                        uid: 'pVueVCZCkKLglEalZ76H',
                        error: e
                    });

                }

            },

            closeTheModal: function() {

                try {

                    /*
                    **  Close the modal
                    **  @component: @Framework/Modals/Modal
                    */

				    this.$refs.viewInvoiceEventModal.handler();

                } catch (e) {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Close the modal component via handler method.',
                        errorType: 'Application',
                        section: 'Invoice Event',
                        uid: 'U6GYxwQ21BuD5PQ9NFT2',
                        error: e
                    });

                } 

            },

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>